// Checkout upsell: offers one product (the Candida Cleanse e-book) when a customer heads to checkout without it.
// Any failure falls through to checkout; the upsell must never block a sale.

class HayaUpsell extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.bypass = false;
    // Capture phase on document: catches the cart page, cart drawer and cart notification checkout buttons
    document.addEventListener('submit', (event) => this.intercept(event), true);
    this.querySelector('[data-upsell-add]').addEventListener('click', () => this.add());
    this.querySelector('[data-upsell-skip]').addEventListener('click', () => this.proceed());
    this.querySelector('[data-upsell-close]').addEventListener('click', () => this.dialog.close());
  }

  async intercept(event) {
    if (this.bypass || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    this.pending = { form: event.target, submitter: event.submitter };
    if (await this.inCart()) this.proceed();
    else this.dialog.showModal();
  }

  async inCart() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      return cart.items.some((item) => item.product_id === Number(this.dataset.productId));
    } catch (error) {
      console.error('Upsell: could not read cart', error);
      return true;
    }
  }

  async add() {
    this.querySelectorAll('button').forEach((button) => (button.disabled = true));
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }),
      });
      if (!response.ok) console.error('Upsell: add to cart failed', response.status);
    } catch (error) {
      console.error('Upsell: add to cart failed', error);
    }
    // Go straight to checkout: resubmitting the cart form would misalign its positional updates[] with the new line
    window.location.href = '/checkout';
  }

  // Continue with the customer's original checkout submit (keeps cart note and quantities from the form)
  proceed() {
    this.dialog.close();
    this.bypass = true;
    const { form, submitter } = this.pending;
    form.requestSubmit(submitter);
  }
}

if (!customElements.get('haya-upsell')) customElements.define('haya-upsell', HayaUpsell);
